"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_text(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "279f492b-7321-430e-8597-5d339ccc7252",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 142.35"
  }, props), /*#__PURE__*/React.createElement("title", null, "sms"), /*#__PURE__*/React.createElement("g", {
    id: "7919386d-4762-43c8-9063-3981b2041ce3",
    "data-name": "Text_ic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "98ab8a27-c599-40a6-b2a5-a9b97fb70a0a",
    "data-name": "Isolationsmodus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5,107.75",
    transform: "translate(-16 -32)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.67,108H60.24L37.88,130.35V108H32A12,12,0,0,1,20,96V48A12,12,0,0,1,32,36h72a12,12,0,0,1,12,12V76",
    transform: "translate(-16 -32)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.76,148l22.35,22.35V148H160a12,12,0,0,0,12-12V88a12,12,0,0,0-12-12H88A12,12,0,0,0,76,88v48a12,12,0,0,0,12,12Z",
    transform: "translate(-16 -32)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "0f3d0365-c1cb-4e65-92b5-ff4148f22e4a",
    "data-name": "<Pfad>",
    x1: 132,
    y1: 68,
    x2: 84,
    y2: 68,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "8e47b139-875a-49aa-a8c5-4af024deab0c",
    "data-name": "<Pfad>",
    x1: 132,
    y1: 92,
    x2: 84,
    y2: 92,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))));
}

var _default = ic_text;
exports.default = _default;